import { useState } from "react";
import { Button } from "../ui/Button";

// Simple Menu and X icons (you can replace with proper icons later)
const MenuIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const XIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const Header = ({ 
  isAuthenticated = false, 
  onLogin, 
  onSignup, 
  onNavigateToDashboard 
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleDashboard = () => {
    if (onNavigateToDashboard) {
      onNavigateToDashboard();
    }
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/lovable-uploads/d03014d5-0014-415e-9d72-84a4474901b6.png" 
              alt="SafeSolo Travel" 
              className="h-14 w-auto"
              onError={(e) => {
                // Fallback if image doesn't load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div className="text-xl font-bold text-teal-600" style={{display: 'none'}}>
              SafeSolo Travel
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('features')} 
              className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('safety')} 
              className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Safety
            </button>
            <button 
              onClick={() => scrollToSection('community')} 
              className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Community
            </button>
          </nav>

          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            {isAuthenticated ? (
              <Button variant="cta" size="default" onClick={handleDashboard}>
                Dashboard
              </Button>
            ) : (
              <>
                <Button variant="ghost" onClick={onLogin}>
                  Login
                </Button>
                <Button variant="cta" onClick={onSignup}>
                  Sign Up
                </Button>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-md hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <XIcon /> : <MenuIcon />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-200 bg-white">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button
                onClick={() => scrollToSection('features')}
                className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 hover:text-teal-600 hover:bg-gray-50 rounded-md transition-colors"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('safety')}
                className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 hover:text-teal-600 hover:bg-gray-50 rounded-md transition-colors"
              >
                Safety
              </button>
              <button
                onClick={() => scrollToSection('community')}
                className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 hover:text-teal-600 hover:bg-gray-50 rounded-md transition-colors"
              >
                Community
              </button>
              <div className="pt-4 border-t border-gray-200 space-y-2">
                {isAuthenticated ? (
                  <Button variant="cta" size="touch" className="w-full" onClick={handleDashboard}>
                    Dashboard
                  </Button>
                ) : (
                  <>
                    <Button variant="ghost" size="touch" className="w-full" onClick={onLogin}>
                      Login
                    </Button>
                    <Button variant="cta" size="touch" className="w-full" onClick={onSignup}>
                      Sign Up
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};